module.exports = __webpack_public_path__ + "NanumSquareEB.9ee5085e37e8ac9dd4aa";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareEB.ttf
// module id = ../../../../../src/assets/font/NanumSquareEB.ttf
// module chunks = styles